/* Devices and pending screens (docs/API.md → Enums). */
export enum DeviceUsage {
    Guest   = 'guest',
    Signage = 'signage',
}

export const DEVICE_USAGES: DeviceUsage[] = [DeviceUsage.Guest, DeviceUsage.Signage]

export enum DeviceStatus {
    Online   = 'online',
    Offline  = 'offline',
    Unpaired = 'unpaired',
}

export enum DeviceOrientation {
    Auto            = 'auto',
    Landscape       = 'landscape',
    Portrait        = 'portrait',
    PortraitFlipped = 'portrait_flipped',
}

export const DEVICE_ORIENTATIONS: DeviceOrientation[] = [
    DeviceOrientation.Auto, DeviceOrientation.Landscape, DeviceOrientation.Portrait, DeviceOrientation.PortraitFlipped,
]

export enum Platform {
    Android = 'android',
    Tizen   = 'tizen',
    WebOS   = 'webos',
    Web     = 'web',
}

export enum PendingMatch {
    Tenant  = 'tenant',
    Network = 'network',
}
